module.exports = __webpack_public_path__ + "img/zjgnsh.0d984b99.png";